import { render } from "./SnippetModal.vue?vue&type=template&id=70f686f3&scoped=true"
import script from "./SnippetModal.vue?vue&type=script&lang=js"
export * from "./SnippetModal.vue?vue&type=script&lang=js"

import "./SnippetModal.vue?vue&type=style&index=0&id=70f686f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f686f3"]])

export default __exports__